import { useState } from 'react';
import { EmptyState } from '@components/common/EmptyState';
import { PageHeader } from '@components/common/PageHeader';
import { SearchableSelect } from '@components/common/SearchableSelect';
import { SectionCard } from '@components/common/SectionCard';
import { useOpportunities } from '@hooks/useCRM';
import { formatDate, formatMoney } from '@lib/format';

const OPPORTUNITY_STAGE_OPTIONS = [
  { id: '', label: 'All stages' },
  { id: 'discovery', label: 'Discovery' },
  { id: 'demo', label: 'Demo' },
  { id: 'proposal', label: 'Proposal' },
  { id: 'closed_won', label: 'Closed won' },
  { id: 'closed_lost', label: 'Closed lost' },
];

export function OpportunitiesPage() {
  const [stage, setStage] = useState('');
  const { data, isLoading } = useOpportunities(stage || undefined);

  return (
    <div className="space-y-8">
      <PageHeader
        title="Opportunities"
        subtitle="Pipeline and revenue conversations created from lead conversion."
      />

      <SectionCard
        title="Pipeline"
        action={(
          <SearchableSelect
            options={OPPORTUNITY_STAGE_OPTIONS}
            value={stage}
            onChange={setStage}
            placeholder="All stages"
            clearable={false}
            aria-label="Opportunity stage"
          />
        )}
      >
      {isLoading ? (
        <div className="loading-row">Loading opportunities…</div>
      ) : data?.items.length ? (
        <div className="kanban-grid">
          {data.items.map((opportunity) => (
            <article key={opportunity.id} className="deal-card">
              <div className="deal-card-top">
                <span className="pill pill-neutral">{opportunity.stage}</span>
                <strong>{formatMoney(opportunity.amount)}</strong>
              </div>
              <h3>{opportunity.name}</h3>
              <p>{opportunity.summary_notes || 'No summary yet'}</p>
              <div className="deal-card-meta">
                <span>{opportunity.pipeline || 'default pipeline'}</span>
                <span>{formatDate(opportunity.close_date)}</span>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <EmptyState title="No opportunities yet" body="Lead conversion can already create backend opportunities; the next pass can add creation flows in the UI." />
      )}
      </SectionCard>
    </div>
  );
}
